<template>
  <SudoStatus
    :globalAdmin="isParentSudo"
    :globalAdminPasswordless="isParentSudoPasswordless"
    :inheretedAdmin="InheretedAdmin"
    :inheretedAdminPasswordless="InheretedAdminPasswordless"
    :item="item"
    :parentType="parentType"
    :showNewWorkflow="showNewWorkflow"
    storeModule="SystemGroupCollection"
    :sudoersContextIsWindows="false"
    :systemGroup="{ id: item.id }"
    :userGroup="userGroup"
    :viewport="viewport"
  />
</template>
<script>
import { ItemTypeConsts } from 'client/util/Constants';
import { has } from 'lodash';
import SudoStatus from 'client/components/ItemTable/BodyComponents/SudoStatus.vue';

export default {
  name: 'SystemGroupSudoStatus',

  components: {
    SudoStatus,
  },

  props: {
    item: {
      required: true,
      type: Object,
    },
    parent: {
      type: Object,
      default: () => {},
    },
    showNewWorkflow: {
      type: Boolean,
      default: false,
    },
    viewport: {
      default: null,
      type: Object,
    },
  },

  data() {
    return {
      parentType: ItemTypeConsts.userGroup,
    };
  },

  computed: {
    InheretedAdmin() {
      return !!(this.userGroup
      && this.userGroup.sudoEnabled
      && !this.userGroup.passwordLessSudoEnabled);
    },

    InheretedAdminPasswordless() {
      return !!(this.userGroup
      && this.userGroup.sudoEnabled
      && this.userGroup.passwordLessSudoEnabled);
    },

    hasParentSudoAttribute() {
      return has(this.parent, 'attributes.sudo');
    },

    isParentSudo() {
      return this.hasParentSudoAttribute && this.parent.attributes.sudo.enabled;
    },

    isParentSudoPasswordless() {
      return this.hasParentSudoAttribute && this.parent.attributes.sudo.withoutPassword;
    },

    userGroup() {
      const parentInfo = { ...(this.parent || {}) };
      return parentInfo;
    },
  },
};
</script>
